import { AxiosError } from 'axios';

interface ApiErrorBody {
  error?: { code?: string; message?: string };
}

/** Достаёт человекочитаемое сообщение из ответа API ({error:{message}}). */
export function apiErrorMessage(err: unknown, fallback = 'Что-то пошло не так'): string {
  if (err instanceof AxiosError) {
    const body = err.response?.data as ApiErrorBody | undefined;
    if (body?.error?.message) return body.error.message;
    if (err.code === 'ERR_NETWORK') return 'Нет связи с сервером';
  }
  return fallback;
}
